const useLocalStorage = () => {
  const getStorageItem = (key: string) => {
    const data = window.localStorage.getItem(key);
    return JSON.parse(data!);
  };
  const getStorageJsonItem = (key: string) => {
    return window.localStorage.getItem(key);
  };

  const setStorageItem = (key: string, value: any) => {
    return window.localStorage.setItem(key, JSON.stringify(value));
  };

  const removeStorageItem = (key: string) => {
    return window.localStorage.removeItem(key);
  };

  const clearStorage = () => {
    return window.localStorage.clear();
  };

  return {
    getStorageItem,
    getStorageJsonItem,
    setStorageItem,
    removeStorageItem,
    clearStorage,
  };
};

export default useLocalStorage;
